import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { InjectionToken } from '@angular/core';

export const API_BASE_ENDPOINT = new InjectionToken<string>('Base for all API endpoints');

export const ApiBaseInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const apiBase = inject(API_BASE_ENDPOINT);
    if (!apiBase) {
        console.error('API_BASE_ENDPOINT token not provided');
    }

    if (req.url.indexOf('http') === 0 || req.url.includes('/i18n/')) {
        return next(req);
    }

    const apiReq = req.clone({
        url: apiBase + req.url,
        headers: req.headers.append('Accept', 'application/json')
    });
    return next(apiReq);
};
